var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgDisplayMediumPrimaryUmbrella = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H50V50H0z",
    transform: "translate(-35 -134) translate(20 100) translate(15 34)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1B7690",
    fillRule: "nonzero",
    d: "M4.836 27.454c.028 0 2.457-1.157 4.688-1.157 1.666 0 3.643 1.58 4.236 2.2l.904.903.903-.903c.622-.62 2.599-2.2 4.265-2.2 1.412 0 3.022 1.129 3.869 1.862v14.977C23.7 45.279 25.45 47 27.57 47c2.146 0 3.869-1.749 3.869-3.864v-2.567h-2.57v2.567c0 .705-.593 1.297-1.299 1.297s-1.3-.592-1.3-1.297V28.159c.848-.733 2.458-1.862 3.87-1.862 1.666 0 3.643 1.58 4.236 2.2l.904.903.904-.903c.62-.62 2.598-2.2 4.264-2.2 2.231 0 4.66 1.157 4.688 1.157l1.864.902v-2.059c0-11.62-9.15-20.082-20.73-20.674V3h-2.54v2.623C12.15 6.215 3 14.677 3 26.297v2.06l1.836-.903z",
    transform: "translate(-35 -134) translate(20 100) translate(15 34)"
  })))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDisplayMediumPrimaryUmbrella);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/display-medium-primary-umbrella.cc5c131188c31e0819ea96ab28a68cc2.svg";